module.exports = __webpack_public_path__ + "static/media/wallpaper-v1.f69487c9.jpg";